<template>
  <SearchCard v-if="user"></SearchCard>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import SearchCard from './SearchCard';

export default {
  name: 'MembersComponent',
  components: { SearchCard },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    ...mapState({
      userStatus: state => state.user
    }),
    ...mapGetters('user', {
      user: 'getUser',
    })
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  }
};
</script>
